module.exports = __webpack_public_path__ + "static/karen-kingsbury.7374af49.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/people/karen-kingsbury.jpg
// module id = 1308
// module chunks = 168707334958949